(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart"]) return;
  try {
    
  function updateQty(index, change) {
    const inputs = document.querySelectorAll('input[name="updates[]"]');
    const input = inputs[index];
    const newValue = parseInt(input.value) + change;
    if (newValue >= 0) {
      input.value = newValue;
    }
  }
  
  document.addEventListener('DOMContentLoaded', function() {
    const form = document.getElementById('cart-form');
    if (form) {
      const updateBtn = form.querySelector('button[name="update"]');
      if (updateBtn) {
        updateBtn.addEventListener('click', function(e) {
          e.preventDefault();
          form.submit();
        });
      }
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kaizen-image-overlay"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function pad(value) {
      return String(value).padStart(2, "0");
    }

    function initTimer(timer) {
      if (!timer || timer.__kiwtoTimer) return;

      var endTime = new Date(timer.dataset.endTime).getTime();
      if (!endTime) return;

      var days = timer.querySelector("[data-days]");
      var hours = timer.querySelector("[data-hours]");
      var minutes = timer.querySelector("[data-minutes]");
      var seconds = timer.querySelector("[data-seconds]");

      function update() {
        var remaining = Math.max(0, endTime - Date.now());
        var totalSeconds = Math.floor(remaining / 1000);

        if (days) days.textContent = Math.floor(totalSeconds / 86400);
        if (hours) hours.textContent = pad(Math.floor((totalSeconds % 86400) / 3600));
        if (minutes) minutes.textContent = pad(Math.floor((totalSeconds % 3600) / 60));
        if (seconds) seconds.textContent = pad(totalSeconds % 60);

        if (remaining <= 0 && timer.__kiwtoTimer) {
          clearInterval(timer.__kiwtoTimer);
          timer.__kiwtoTimer = null;
        }
      }

      update();
      timer.__kiwtoTimer = setInterval(update, 1000);
    }

    function init(root) {
      if (!root) return;
      root.querySelectorAll("[data-kiwto-timer]").forEach(initTimer);
    }

    document.addEventListener("DOMContentLoaded", function () {
      init(document);
    });

    document.addEventListener("shopify:section:load", function (event) {
      init(event.target);
    });

    document.addEventListener("shopify:section:unload", function (event) {
      event.target.querySelectorAll("[data-kiwto-timer]").forEach(function (timer) {
        if (timer.__kiwtoTimer) {
          clearInterval(timer.__kiwtoTimer);
          timer.__kiwtoTimer = null;
        }
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tw-age-verifier"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var key = 'tw_age_verified';
    if (document.cookie.indexOf(key + '=1') !== -1) return;
    var el = document.querySelector('[data-tw-age-verifier]');
    if (!el) return;
    el.classList.remove('tw-hidden');
    el.setAttribute('aria-hidden', 'false');
    el.querySelector('[data-tw-age-approve]') && el.querySelector('[data-tw-age-approve]').addEventListener('click', function() {
      document.cookie = key + '=1; path=/; max-age=31536000';
      el.classList.add('tw-hidden');
      el.setAttribute('aria-hidden', 'true');
    });
    el.querySelector('[data-tw-age-decline]') && el.querySelector('[data-tw-age-decline]').addEventListener('click', function() {
      el.querySelector('.tw-age-verifier__content').classList.add('tw-hidden');
      el.querySelector('.tw-age-verifier__decline').classList.remove('tw-hidden');
    });
    el.querySelector('[data-tw-age-return]') && el.querySelector('[data-tw-age-return]').addEventListener('click', function() {
      el.querySelector('.tw-age-verifier__decline').classList.add('tw-hidden');
      el.querySelector('.tw-age-verifier__content').classList.remove('tw-hidden');
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tw-cart-upsell"] && !Shopify.designMode) return;
  try {
    
  (function() {
    document.querySelectorAll('.cart-upsell--fetch').forEach(function(el) {
      if (!el.dataset.url) return;
      var track = el.querySelector('[data-upsell-track]');
      if (!track) return;
      fetch(el.dataset.url)
        .then(function(r) { return r.ok ? r.text() : Promise.reject(); })
        .then(function(html) {
          var wrap = document.createElement('div');
          wrap.innerHTML = html;
          var sectionId = (el.dataset.sectionId || 'tw-cart-upsell').replace(/\W/g, '-');
          var remote = wrap.querySelector('#shopify-section-' + sectionId + ' [data-upsell-track]');
          if (!remote) remote = wrap.querySelector('[data-upsell-track]');
          if (remote && remote.children.length > 0) {
            track.innerHTML = remote.innerHTML;
          } else {
            el.style.display = 'none';
          }
        })
        .catch(function() { el.style.display = 'none'; });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tw-collection-grid"] && !Shopify.designMode) return;
  try {
    
    (() => {
      const swiperEl = document.querySelector('[data-cg-swiper]');
      if (!swiperEl) return;
      const root = swiperEl.closest('section[data-section-id]');
      if (!root) return;
      const SECTION_ID = root.getAttribute('data-section-id');

      const toBool = (v) => String(v) === 'true' || String(v) === '1';

      const init = () => {
        if (!window.Swiper) return false;

        const prev = swiperEl.querySelector('[data-cg-prev]');
        const next = swiperEl.querySelector('[data-cg-next]');
        const pagination = swiperEl.querySelector('[data-cg-pagination]');

        const spvM = parseFloat(swiperEl.getAttribute('data-spv-m') || 1);
        const spvT = parseFloat(swiperEl.getAttribute('data-spv-t') || 2);
        const spvD = parseFloat(swiperEl.getAttribute('data-spv-d') || 3);
        const gap = Number(swiperEl.getAttribute('data-gap') || 16);

        const loop = toBool(swiperEl.getAttribute('data-loop'));
        const autoplayEnabled = toBool(swiperEl.getAttribute('data-autoplay'));
        const speed = Number(swiperEl.getAttribute('data-speed') || 3000);
        const effect = swiperEl.getAttribute('data-effect') || 'slide';
        const speedTransition = Number(swiperEl.getAttribute('data-speed-transition') || 300);
        const centered = toBool(swiperEl.getAttribute('data-centered'));
        const grab = toBool(swiperEl.getAttribute('data-grab'));
        const freeMode = toBool(swiperEl.getAttribute('data-free-mode'));
        const pauseOnHover = toBool(swiperEl.getAttribute('data-pause-on-hover'));

        if (swiperEl.__twSwiper) {
          try { swiperEl.__twSwiper.destroy(true, true); } catch(e) {}
          swiperEl.__twSwiper = null;
        }

        const cfg = {
          slidesPerView: spvM,
          spaceBetween: gap,
          watchOverflow: true,
          speed: speedTransition,
          effect: effect,
          centeredSlides: centered,
          grabCursor: grab,
          freeMode: freeMode,
          loop: loop,
          breakpoints: {
            768: { slidesPerView: spvT, centeredSlides: centered },
            1024: { slidesPerView: spvD, centeredSlides: centered }
          }
        };

        // Navigation
        if (prev && next) {
          cfg.navigation = { prevEl: prev, nextEl: next };
        }

        // Pagination
        if (pagination) {
          cfg.pagination = {
            el: pagination,
            clickable: true,
            dynamicBullets: false
          };
        }

        // Autoplay
        if (autoplayEnabled) {
          cfg.autoplay = {
            delay: speed,
            disableOnInteraction: false,
            pauseOnMouseEnter: pauseOnHover
          };
        }

        // Effect-specific settings
        if (effect === 'fade') {
          cfg.fadeEffect = { crossFade: true };
        } else if (effect === 'cube') {
          cfg.cubeEffect = {
            shadow: true,
            slideShadows: true,
            shadowOffset: 20,
            shadowScale: 0.94
          };
        } else if (effect === 'coverflow') {
          cfg.coverflowEffect = {
            rotate: 50,
            stretch: 0,
            depth: 100,
            modifier: 1,
            slideShadows: true
          };
        } else if (effect === 'flip') {
          cfg.flipEffect = {
            slideShadows: true,
            limitRotation: true
          };
        }

        swiperEl.__twSwiper = new window.Swiper(swiperEl, cfg);
        return true;
      };

      let tries = 0;
      const t = setInterval(() => {
        tries += 1;
        if (init() || tries > 40) clearInterval(t);
      }, 100);

      document.addEventListener('shopify:section:load', (e) => {
        if (e?.detail?.sectionId != SECTION_ID) return;
        setTimeout(init, 80);
      });
      document.addEventListener('shopify:section:select', (e) => {
        if (e?.detail?.sectionId != SECTION_ID) return;
        setTimeout(init, 80);
      });
    })();
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tw-libro-reclamaciones"] && !Shopify.designMode) return;
  try {
    
  function initLibroReclamacionesDate() {
    document.querySelectorAll('.lr-current-date').forEach(function (el) {
      var loc = el.getAttribute('data-locale') || 'es-ES';
      var dateOptions = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' };
      var today = new Date().toLocaleDateString(loc, dateOptions);
      today = today.charAt(0).toUpperCase() + today.slice(1);
      today = today.replace(/,/g, '');
      el.textContent = today;
    });
  }
  document.addEventListener('DOMContentLoaded', initLibroReclamacionesDate);
  document.addEventListener('shopify:section:load', initLibroReclamacionesDate);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tw-main-article"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initArticleSwiper(root) {
      if (!root) return;
      var el = root.querySelector('[data-tw-article-swiper]');
      if (!el || typeof window.Swiper === 'undefined') return;
      if (el._twArticleSwiper) {
        try {
          el._twArticleSwiper.destroy(true, true);
        } catch (e) {}
        el._twArticleSwiper = null;
      }
      var prev = root.querySelector('[data-tw-article-prev]');
      var next = root.querySelector('[data-tw-article-next]');
      var pagination = root.querySelector('[data-tw-article-pagination]');
      var cfg = {
        slidesPerView: 1,
        spaceBetween: 16,
        watchOverflow: true,
        observer: true,
        observeParents: true,
        breakpoints: {
          768: { slidesPerView: 2, spaceBetween: 20 },
          1024: { slidesPerView: 3, spaceBetween: 24 }
        }
      };
      if (prev && next) cfg.navigation = { prevEl: prev, nextEl: next };
      if (pagination) cfg.pagination = { el: pagination, clickable: true };
      el._twArticleSwiper = new window.Swiper(el, cfg);
      [80, 250, 500].forEach(function (ms) {
        setTimeout(function () {
          try {
            if (el._twArticleSwiper) el._twArticleSwiper.update();
          } catch (e) {}
        }, ms);
      });
    }
    function bootAll() {
      document.querySelectorAll('[data-tw-article-root]').forEach(function (root) {
        var tries = 0;
        var timer = setInterval(function () {
          tries++;
          if (typeof window.Swiper !== 'undefined') {
            initArticleSwiper(root);
            clearInterval(timer);
          } else if (tries > 50) clearInterval(timer);
        }, 100);
      });
    }
    function bootOne(sectionId) {
      var root = document.querySelector('[data-tw-article-root="' + sectionId + '"]');
      if (!root) return;
      var tries = 0;
      var timer = setInterval(function () {
        tries++;
        if (typeof window.Swiper !== 'undefined') {
          initArticleSwiper(root);
          clearInterval(timer);
        } else if (tries > 50) clearInterval(timer);
      }, 100);
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', bootAll);
    } else {
      bootAll();
    }
    document.addEventListener('shopify:section:load', function (e) {
      setTimeout(function () {
        bootOne(String(e.detail.sectionId));
      }, 120);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tw-main-collection"] && !Shopify.designMode) return;
  try {
    
(function() {
  if (window.__twMainCollectionToolbar) return;
  window.__twMainCollectionToolbar = true;

  function syncBodyScroll() {
    var open = document.querySelector('[data-tw-sidebar-overlay].is-open');
    document.documentElement.style.overflow = open ? 'hidden' : '';
  }

  function openDrawer(root) {
    var overlay = root.querySelector('[data-tw-sidebar-overlay]');
    var panel = root.querySelector('[data-tw-drawer-panel]');
    var btn = root.querySelector('[data-tw-sidebar-open]');
    if (overlay) {
      overlay.classList.add('is-open');
      overlay.classList.remove('tw-pointer-events-none', 'tw-opacity-0');
      overlay.setAttribute('aria-hidden', 'false');
    }
    if (panel) {
      panel.classList.add('is-open');
      panel.classList.remove('-tw-translate-x-full');
    }
    if (btn) btn.setAttribute('aria-expanded', 'true');
    // Body state is used by CSS to resolve header/stacking context while the drawer is open.
    document.body.classList.add('tw-filter-drawer-open');
    syncBodyScroll();
  }

  function closeDrawer(root) {
    var overlay = root.querySelector('[data-tw-sidebar-overlay]');
    var panel = root.querySelector('[data-tw-drawer-panel]');
    var btn = root.querySelector('[data-tw-sidebar-open]');
    if (overlay) {
      overlay.classList.remove('is-open');
      overlay.classList.add('tw-pointer-events-none', 'tw-opacity-0');
      overlay.setAttribute('aria-hidden', 'true');
    }
    if (panel) {
      panel.classList.remove('is-open');
      panel.classList.add('-tw-translate-x-full');
    }
    if (btn) btn.setAttribute('aria-expanded', 'false');
    document.body.classList.remove('tw-filter-drawer-open');
    syncBodyScroll();
  }

  // Delegación global: el botón puede ser reemplazado por AJAX
  document.addEventListener('click', function(e) {
    var openBtn = e.target.closest && e.target.closest('[data-tw-sidebar-open]');
    if (openBtn) {
      var root = openBtn.closest('[data-tw-collection-root]');
      if (root) {
        e.preventDefault();
        openDrawer(root);
      }
      return;
    }
    var closeBtn = e.target.closest && e.target.closest('[data-tw-sidebar-close]');
    if (closeBtn) {
      var rootC = closeBtn.closest('[data-tw-collection-root]');
      if (rootC) {
        e.preventDefault();
        closeDrawer(rootC);
      }
      return;
    }
    var overlayHit = e.target.closest && e.target.closest('[data-tw-sidebar-overlay]');
    if (overlayHit && overlayHit.classList.contains('is-open')) {
      var rootO = overlayHit.closest('[data-tw-collection-root]');
      if (rootO) closeDrawer(rootO);
      return;
    }
    var viewBtn = e.target.closest && e.target.closest('.tw-collection-toolbar__views [data-tw-view]');
    if (viewBtn) {
      e.preventDefault();
      var rootV = viewBtn.closest('[data-tw-collection-root]');
      if (!rootV || rootV.getAttribute('data-enable-view-toggle') !== 'true') return;
      var v = viewBtn.getAttribute('data-tw-view');
      var mode = v === 'list' ? 'list' : v.replace(/^grid-/, '');
      twApplyCollectionView(rootV, mode);
    }
  });

  document.addEventListener('change', function(e) {
    var sel = e.target;
    if (!sel.matches || !sel.matches('select[name="sort_by"]')) return;
    var form = sel.closest('.tw-main-collection__sort-form');
    if (form) form.submit();
  });

  document.addEventListener('keydown', function(e) {
    if (e.key !== 'Escape') return;
    document.querySelectorAll('[data-tw-collection-root]').forEach(function(root) {
      var overlay = root.querySelector('[data-tw-sidebar-overlay]');
      if (overlay && overlay.classList.contains('is-open')) closeDrawer(root);
    });
  });

  // Resize handler - clean body class on viewport change
  (function() {
    var resizeTimer;
    window.addEventListener('resize', function() {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function() {
        document.body.classList.remove('tw-filter-drawer-open');
      }, 150);
    });
  })();

  // View toggle
  function twClampGridCols(n) {
    n = parseInt(n, 10);
    if (!isFinite(n)) return 4;
    return Math.min(4, Math.max(2, n));
  }
  function twDefaultGridCols(root) {
    return String(twClampGridCols(root.getAttribute('data-cols-desktop-default')));
  }
  function twNormalizeCollectionView(saved, root) {
    if (saved === 'list') return 'list';
    if (saved === '2' || saved === '3' || saved === '4') return saved;
    if (saved === 'grid') return twDefaultGridCols(root);
    return null;
  }
  function twSyncCollectionViewButtons(root, mode) {
    var group = root.querySelector('.tw-collection-toolbar__views');
    if (!group) return;
    group.querySelectorAll('[data-tw-view]').forEach(function(b) {
      var v = b.getAttribute('data-tw-view');
      var on = v === 'list' ? mode === 'list' : mode !== 'list' && v === 'grid-' + mode;
      b.classList.toggle('tw-collection-view-btn--active', on);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
  }
  function twApplyCollectionView(root, mode) {
    if (!root || !mode) return;
    var storageKey = 'tw-collection-view-' + root.getAttribute('data-section-id');
    if (mode === 'list') {
      root.classList.add('tw-main-collection--list');
      root.style.removeProperty('--mcp-cols-m');
      root.style.removeProperty('--mcp-cols-t');
      root.style.removeProperty('--mcp-cols-d');
    } else {
      root.classList.remove('tw-main-collection--list');
      var n = String(twClampGridCols(mode));
      root.style.setProperty('--mcp-cols-m', n);
      root.style.setProperty('--mcp-cols-t', n);
      root.style.setProperty('--mcp-cols-d', n);
      mode = n;
    }
    try { sessionStorage.setItem(storageKey, mode === 'list' ? 'list' : mode); } catch (err) {}
    twSyncCollectionViewButtons(root, mode);
  }

  function restoreCollectionViews() {
    document.querySelectorAll('[data-tw-collection-root][data-enable-view-toggle="true"]').forEach(function(root) {
      var sectionId = root.getAttribute('data-section-id');
      var saved = null;
      try { saved = sessionStorage.getItem('tw-collection-view-' + sectionId); } catch (err) {}
      var mode = twNormalizeCollectionView(saved, root);
      if (mode == null) return;
      twApplyCollectionView(root, mode);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', restoreCollectionViews);
  } else {
    restoreCollectionViews();
  }
  document.addEventListener('shopify:section:load', restoreCollectionViews);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tw-main-product"] && !Shopify.designMode) return;
  try {
    
  (function() {
    function normalizeFastBundleText(el) {
      return (el && el.textContent ? el.textContent : '').replace(/\s+/g, ' ').trim().toLowerCase();
    }
    function getFastBundleClassName(el) {
      if (!el || !el.className) return '';
      return typeof el.className === 'string' ? el.className : String(el.getAttribute('class') || '');
    }
    function getFastBundleHaystack(el) {
      return [el && el.id || '', getFastBundleClassName(el), normalizeFastBundleText(el)].join(' ').toLowerCase();
    }

    var bundleAnalyticsState = { started: false, completed: false, lastInteractionAt: 0 };

    function pushBundleEvent(eventName, detail) {
      var section = document.querySelector('section[id^="tw-main-product-"]');
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(Object.assign({
        event: eventName,
        product_id: section ? section.getAttribute('data-product-id') : '',
        product_handle: section ? section.getAttribute('data-product-handle') : '',
        product_template_suffix: section ? section.getAttribute('data-product-template-suffix') : ''
      }, detail || {}));
    }

    function normalizeBundleText(text) {
      return String(text || '').toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/\s+/g, ' ').trim();
    }

    function isBundleInteractionTarget(target) {
      if (!target || !target.closest) return null;
      return target.closest('[data-fast-bundle-anchor], [id^="rbr-container-element"], [class*="rbrBundle"], [class*="BundleBuilder"], [class*="MixMatch"], [class*="mix_and_match"], [class*="mnm"], [class*="CmmBap"]');
    }

    function getBundleActionElement(target) {
      if (!target || !target.closest) return null;

      var direct = target.closest('button, [role="button"], input[type="button"], input[type="submit"], input[type="checkbox"], input[type="radio"], a');
      if (direct) return direct;

      var anchor = isBundleInteractionTarget(target);
      var current = target;
      var level = 0;

      while (current && current !== anchor && current !== document.body && level < 5) {
        var text = normalizeBundleText(current.textContent || current.value || '');
        if (text === '+' || text === '-' || text === '−' || text.indexOf('anadir') > -1 || text.indexOf('add') > -1 || text.indexOf('quitar') > -1 || text.indexOf('eliminar') > -1 || text.indexOf('remove') > -1) {
          return current;
        }
        current = current.parentElement;
        level++;
      }

      return null;
    }

    function getBundlePlanKey(section) {
      var suffix = section ? section.getAttribute('data-product-template-suffix') : '';
      var handle = section ? section.getAttribute('data-product-handle') : '';
      var combined = normalizeBundleText([suffix, handle].join(' '));

      if (combined.indexOf('toddler-s') > -1 || combined.indexOf('pack-s') > -1 || combined.indexOf('texturas-pack-s') > -1) return 's';
      if (combined.indexOf('toddler-m') > -1 || combined.indexOf('pack-m') > -1 || combined.indexOf('texturas-pack-m') > -1) return 'm';
      if (combined.indexOf('toddler-l') > -1 || combined.indexOf('pack-l') > -1 || combined.indexOf('texturas-pack-l') > -1) return 'l';
      return '';
    }

    function getBundleProgressConfig(section) {
      var planKey = getBundlePlanKey(section);
      if (planKey === 's') return { groups: [{ labels: ['snacks tradicionales', 'snacks premium'], max: 2 }] };
      if (planKey === 'm') return { groups: [{ labels: ['snacks tradicionales', 'snacks premium'], max: 4 }, { labels: ['add-ons', 'proteinas - addons', 'proteinas'], max: 2 }] };
      if (planKey === 'l') return { groups: [{ labels: ['snacks tradicionales', 'snacks premium'], max: 6 }, { labels: ['add-ons', 'proteinas - addons', 'proteinas'], max: 3 }, { labels: ['proteinas', 'proteina'], max: 1 }] };
      return null;
    }

    function getBundleSelectedCount(anchor, group) {
      if (!anchor || !group) return 0;
      var total = 0;
      var buckets = group.buckets || (group.labels ? group.labels.map(function(l) { return [l]; }) : []);
      var candidates = Array.prototype.slice.call(anchor.querySelectorAll('div, section, article, li, span'));
      candidates.push(anchor);
      buckets.forEach(function(bucket) {
        var bucketMax = 0;
        bucket.forEach(function(label) {
          var nl = normalizeBundleText(label);
          if (!nl) return;
          candidates.forEach(function(el) {
            var text = normalizeBundleText(el && el.innerText || el && el.textContent || '');
            if (!text || text.indexOf(nl) === -1) return;
            var idx = text.indexOf(nl);
            var after = text.slice(idx, idx + 260);
            var m = after.match(/(\d+)\s*(anadido|añadido|agregado|seleccionado|selected|added)/);
            if (m) bucketMax = Math.max(bucketMax, Number(m[1] || 0));
          });
        });
        total += bucketMax;
      });
      return total;
    }


    function isBundleAddAction(target) {
      var control = getBundleActionElement(target);
      if (!control) return false;
      var text = normalizeBundleText(control.innerText || control.textContent || control.value || (control.getAttribute && control.getAttribute('aria-label')) || '');
      return text === '+' || text.indexOf('anadir') > -1 || text.indexOf('agregar') > -1 || text.indexOf('add') > -1 || text.indexOf('increase') > -1;
    }

    function updateBundleProgress(anchor) {
      if (!anchor) return;
      var section = anchor.closest('section[id^="tw-main-product-"]');
      var progress = section && section.querySelector('[data-bundle-progress]');
      var config   = getBundleProgressConfig(section);
      if (!progress || !config) return;
      var text = normalizeBundleText(anchor.innerText || anchor.textContent || '');
      if (!text || text.indexOf('anadido') === -1) { progress.hidden = true; return; }
      var totalMissing = 0, totalSelected = 0, totalMax = 0;
      config.groups.forEach(function(group) {
        var selected = getBundleSelectedCount(anchor, group);
        totalSelected += selected; totalMax += group.max;
        totalMissing  += Math.max(0, group.max - selected);
      });
      if (!totalMax) { progress.hidden = true; return; }
      progress.hidden    = false;
      progress.textContent = totalMissing > 0 ? 'Te faltan ' + totalMissing + ' productos por elegir.' : 'Pack completo.';
      if (totalMissing === 0 && !bundleAnalyticsState.completed) {
        bundleAnalyticsState.completed = true;
        pushBundleEvent('bundle_completed', { selected_items: totalSelected, expected_items: totalMax });
      }
      if (totalMissing > 0) bundleAnalyticsState.completed = false;
    }

    function updateAllBundleProgress() {
      document.querySelectorAll('[data-fast-bundle-anchor]').forEach(updateBundleProgress);
      if (window.__yomiBundlePerfCounters) window.__yomiBundlePerfCounters.progressUpdates += 1;
      if (window.__yomiBundlePerformanceDebug) {
        console.log('[Bundle Performance]', {
          action: 'progress-update',
          progressUpdates: window.__yomiBundlePerfCounters ? window.__yomiBundlePerfCounters.progressUpdates : 0
        });
      }
    }

    var bundleProgressTimer = null;
    function scheduleBundleProgressUpdate() {
      if (bundleProgressTimer) return;
      if (window.__yomiBundlePerfCounters) window.__yomiBundlePerfCounters.timersActive += 1;
      bundleProgressTimer = window.setTimeout(function() {
        bundleProgressTimer = null;
        if (window.__yomiBundlePerfCounters) {
          window.__yomiBundlePerfCounters.timersActive = Math.max(0, window.__yomiBundlePerfCounters.timersActive - 1);
        }
        updateAllBundleProgress();
        document.dispatchEvent(new CustomEvent('tw:bundle-selection-changed'));
      }, 120);
    }

    // Analytics/progress only. Validation is loaded by the S/M/L snippets above.
    if (!window.__twBundleAnalyticsClickInitialized) {
      document.addEventListener('click', function(event) {
        var bundleRoot = isBundleInteractionTarget(event.target);
        if (!bundleRoot) return;
        bundleAnalyticsState.lastInteractionAt = Date.now();
        if (!bundleAnalyticsState.started) {
          bundleAnalyticsState.started = true;
          pushBundleEvent('bundle_selection_started');
        }
        if (isBundleAddAction(event.target)) {
          pushBundleEvent('bundle_item_selected');
          scheduleBundleProgressUpdate();
        }
      }, true);
      window.__twBundleAnalyticsClickInitialized = true;
    }

    if (!window.__twBundleAnalyticsFetchPatched) {
      window.__twBundleAnalyticsFetchPatched = true;
      var bundleAnalyticsFetch = window.fetch;
      window.fetch = function(input, init) {
        var fetchArgs = arguments;
        var url       = typeof input === 'string' ? input : (input && input.url) || '';
        var isRecentAdd = url.indexOf('/cart/add') !== -1 && Date.now() - bundleAnalyticsState.lastInteractionAt < 15000;
        return bundleAnalyticsFetch.apply(this, fetchArgs).then(function(response) {
          if (isRecentAdd && response && response.ok) {
            pushBundleEvent('bundle_added_to_cart');
            document.dispatchEvent(new CustomEvent('cart:item-added'));
          }
          return response;
        });
      };
    }

    function isLikelyFastBundle(el) {
      if (!el || el.nodeType !== 1) return false;
      var h = getFastBundleHaystack(el);
      return (
        h.indexOf('rbr') > -1 || h.indexOf('fbp') > -1 || h.indexOf('fastbundle') > -1 ||
        h.indexOf('fast-bundle') > -1 || h.indexOf('fast_bundle') > -1 || h.indexOf('fast bundle') > -1 ||
        h.indexOf('volume_position') > -1 || h.indexOf('mnm') > -1 ||
        (h.indexOf('mix') > -1 && h.indexOf('match') > -1) ||
        h.indexOf('arma tu') > -1 ||
        (h.indexOf('selecciona') > -1 && (h.indexOf('productos') > -1 || h.indexOf('items') > -1 || h.indexOf('pack') > -1)) ||
        h.indexOf('yomiparty') > -1 || h.indexOf('yomi party') > -1 ||
        (h.indexOf('agrega') > -1 && h.indexOf('pack') > -1) ||
        h.indexOf('rbrBundle') > -1
      );
    }

    function isFastBundleModalLike(el) {
      if (!el || el.nodeType !== 1) return false;
      if (el.matches('[role="dialog"], [aria-modal="true"]')) return true;
      if (el.closest('[role="dialog"], [aria-modal="true"]')) return true;
      if (el.closest('.tw-quickview-modal, .cart-drawer, [data-tw-quickview-modal], [data-tw-search-drawer]')) return true;
      var current = el;
      while (current && current.nodeType === 1 && current !== document.body) {
        var h = getFastBundleHaystack(current);
        if (h.indexOf('modal') > -1 || h.indexOf('popup') > -1 || h.indexOf('overlay') > -1 ||
            h.indexOf('backdrop') > -1 || h.indexOf('portal') > -1 || h.indexOf('drawer') > -1 ||
            h.indexOf('dialog') > -1 || h.indexOf('toast') > -1 || h.indexOf('notification') > -1) return true;
        current = current.parentElement;
      }
      if (window.getComputedStyle) { var s = window.getComputedStyle(el); if (s && s.position === 'fixed') return true; }
      return false;
    }

    function isMovableFastBundle(el) { return isLikelyFastBundle(el) && !isFastBundleModalLike(el); }

    function getAnchoredFastBundle(anchor) {
      if (!anchor) return null;
      var children = Array.prototype.slice.call(anchor.children);
      for (var i = 0; i < children.length; i++) { if (isMovableFastBundle(children[i])) return children[i]; }
      return null;
    }

    function prepareFastBundleForProductForm(bundle, anchor) {
      if (!bundle) return;
      var form = anchor && anchor.closest('form');
      if (!form || form.getAttribute('data-fast-bundle-submit-guard') === 'true') return;
      form.setAttribute('data-fast-bundle-submit-guard', 'true');
      form.addEventListener('submit', function(event) {
        var submitter = event.submitter || document.activeElement;
        if (submitter && submitter.closest && submitter.closest('[data-fast-bundle-anchor]')) event.preventDefault();
      });
    }

    function getFastBundleMoveContainer(el, anchor) {
      if (!el || !anchor) return null;
      if (el.id && el.id.indexOf('rbr-container-element') === 0) return el;
      if (isFastBundleModalLike(el)) return null;
      var form = anchor.closest('form') || document.querySelector('.tw-product-form');
      if (form) {
        var child = el;
        while (child && child.parentElement && child.parentElement !== form) child = child.parentElement;
        if (child && child.parentElement === form && child !== anchor && isMovableFastBundle(child)) return child;
      }
      var container = (el.id && el.id.indexOf('rbr-container-element') === 0) ? el
        : el.closest('[id^="rbr-container-element"], .rbr-desktop, .rbr-mobile, .rbrBundleBuilder, [class*="CmmBap_container"], [class*="MainSection_container"], [id*="fbp"], [class*="fbp"], [id*="FBP"], [class*="FBP"], [id*="FastBundle"], [class*="FastBundle"], [class*="mnm"], [class*="MnM"], [class*="MixMatch"], [class*="rbrBundle"]') || el;
      return isMovableFastBundle(container) ? container : null;
    }

    function getFastBundleElement(anchor) {
      var selectors = [
        '.rbrProductBundlePosition > *', '.rbrVolumeContainer > *', '.rbrFBTPosition > *', '.rbrAddOnContainer > *',
        '#rbr-container-element-true', '[id^="rbr-container-element"]', '.rbr-desktop', '.rbr-mobile', '.rbrBundleBuilder',
        '[class*="CmmBap_container"]', '[class*="MainSection_container"]',
        '[id*="fastbundle"]', '[class*="fastbundle"]', '[id*="fast-bundle"]', '[class*="fast-bundle"]',
        '[id*="fast_bundle"]', '[class*="fast_bundle"]', '[id*="FastBundle"]', '[class*="FastBundle"]',
        '[id*="fbp"]', '[class*="fbp"]', '[id*="FBP"]', '[class*="FBP"]',
        '[data-fbp]', '[data-fast-bundle]', '[data-fastbundle]', '[data-rbr]',
        '[class*="rbr"]', '[class*="mnm"]', '[class*="MnM"]', '[class*="MixMatch"]',
        '[class*="mix-match"]', '[class*="mix_match"]', '[class*="rbrBundle"]', '[class*="mm-section"]',
        '[data-rbundle]', '[class*="MnMContainer"]', '[class*="mixMatchContainer"]',
        '[class*="mix_and_match"]', '[class*="mnM"]', '[class*="BundleBuilder"]', '[data-bundle-builder]',
        '[class*="pmm_new"]', '[class*="PmmContainer"]', '[class*="CmmContainer"]', '[class*="CmmBap"]'
      ];
      for (var i = 0; i < selectors.length; i++) {
        var matches = document.querySelectorAll(selectors[i]);
        for (var j = 0; j < matches.length; j++) {
          var el = matches[j];
          if (!el || el.nodeType !== 1) continue;
          if (el.matches('script, style, link, template')) continue;
          if (el.hasAttribute('data-fast-bundle-anchor')) continue;
          if (el.closest('[data-fast-bundle-anchor]')) continue;
          if (el.closest('.tw-product-media, .tw-sticky-add-cart, .cart-drawer')) continue;
          var container = getFastBundleMoveContainer(el, anchor);
          if (container && !container.closest('[data-fast-bundle-anchor]')) return container;
        }
      }
      var form = anchor && (anchor.closest('form') || document.querySelector('.tw-product-form'));
      if (form) {
        var directChildren = Array.prototype.slice.call(form.children);
        for (var k = 0; k < directChildren.length; k++) {
          var child = directChildren[k];
          if (!child || child === anchor) continue;
          if (child.matches('input, script, style, link, template')) continue;
          if (child.closest('[data-fast-bundle-anchor]')) continue;
          if (isMovableFastBundle(child)) return child;
        }
        var likelyMatches = form.querySelectorAll('div, section, article');
        for (var l = 0; l < likelyMatches.length; l++) {
          var likely = likelyMatches[l];
          if (!likely || likely === anchor) continue;
          if (likely.closest('[data-fast-bundle-anchor]')) continue;
          if (!isMovableFastBundle(likely)) continue;
          var likelyContainer = getFastBundleMoveContainer(likely, anchor);
          if (likelyContainer && !likelyContainer.closest('[data-fast-bundle-anchor]')) return likelyContainer;
        }
      }
      var direct = document.getElementById('rbr-container-element-true');
      if (direct && isLikelyFastBundle(direct)) return direct;
      return null;
    }

    var fastBundleObserver = null;
    function disconnectFastBundleObserver() { if (fastBundleObserver) { fastBundleObserver.disconnect(); fastBundleObserver = null; } }

    function ensureFastBundleAnchorAfterPrice(anchor) {
      if (!anchor) return;
      var section   = anchor.closest('section[id^="tw-main-product-"]');
      var price     = section && section.querySelector('[id^="price-"]');
      var dateField = section && section.querySelector('[data-bundle-date-field]');
      if (!price || !price.parentNode) return;
      if (price.nextElementSibling !== anchor) price.parentNode.insertBefore(anchor, price.nextSibling);
      if (dateField && anchor.nextElementSibling !== dateField) anchor.parentNode.insertBefore(dateField, anchor.nextSibling);
    }

    function moveFastBundleBelowPrice() {
      var anchor = document.querySelector('[data-fast-bundle-anchor]');
      if (!anchor) return false;
      ensureFastBundleAnchorAfterPrice(anchor);
      var anchoredBundle = getAnchoredFastBundle(anchor);
      if (anchoredBundle) { prepareFastBundleForProductForm(anchoredBundle, anchor); updateBundleProgress(anchor); }
      var bundle = getFastBundleElement(anchor);
      if (!bundle) return Boolean(anchoredBundle);
      if (anchor.contains(bundle)) { prepareFastBundleForProductForm(bundle, anchor); updateBundleProgress(anchor); return true; }
      anchor.appendChild(bundle);
      anchor.style.display = 'block';
      prepareFastBundleForProductForm(bundle, anchor);
      updateBundleProgress(anchor);
      return true;
    }

    var fastBundleMoveAttempts = 0;
    var fastBundleMoveTimer = null;
    var fastBundleReady = false;

    function scheduleFastBundleMove() {
      if (fastBundleReady) return;
      if (fastBundleMoveTimer && window.__yomiBundlePerfCounters) {
        window.__yomiBundlePerfCounters.timersActive = Math.max(0, window.__yomiBundlePerfCounters.timersActive - 1);
      }
      fastBundleMoveTimer = null;

      fastBundleReady = moveFastBundleBelowPrice();
      fastBundleMoveAttempts++;

      if (fastBundleReady) {
        if (fastBundleMoveTimer) {
          window.clearTimeout(fastBundleMoveTimer);
          fastBundleMoveTimer = null;
        }
        return;
      }

      /*
       * Máximo 8 segundos. Antes se ejecutaba cada 250 ms durante 30 s,
       * compitiendo con la interacción del cliente.
       */
      if (fastBundleMoveAttempts < 32) {
        if (window.__yomiBundlePerfCounters) window.__yomiBundlePerfCounters.timersActive += 1;
        fastBundleMoveTimer = window.setTimeout(scheduleFastBundleMove, 250);
      }
    }

    scheduleFastBundleMove();
    window.addEventListener('load', function() {
      if (!fastBundleReady) scheduleFastBundleMove();
    }, { once: true });

    if (window.MutationObserver && !fastBundleReady) {
      var fastBundleMoveQueued = false;

      fastBundleObserver = new MutationObserver(function() {
        if (fastBundleMoveQueued || fastBundleReady) return;

        fastBundleMoveQueued = true;
        window.requestAnimationFrame(function() {
          fastBundleMoveQueued = false;
          fastBundleReady = moveFastBundleBelowPrice();

          if (fastBundleReady) {
            updateAllBundleProgress();
            disconnectFastBundleObserver();
          }
        });
      });

      fastBundleObserver.observe(document.body, {
        childList: true,
        subtree: true
      });

      window.setTimeout(disconnectFastBundleObserver, 8000);
      document.addEventListener('shopify:section:unload', function() {
        disconnectFastBundleObserver();
      }, { once: true });
    }

    window.setTimeout(updateAllBundleProgress, 500);

    var unitGateLocked = document.querySelector('section[id^="tw-main-product-"][data-unit-gate-locked="true"]') !== null;

    if (!window.__twGetCartSafely) {
      window.__twCartCache = window.__twCartCache || null;
      window.__twCartCacheTimestamp = window.__twCartCacheTimestamp || 0;
      window.__twCartRequestPromise = window.__twCartRequestPromise || null;
      window.__twCartCacheTtl = window.__twCartCacheTtl || 1000;

      window.__twGetCartSafely = function(force) {
        var now = Date.now();

        if (!force && window.__twCartCache && now - window.__twCartCacheTimestamp < window.__twCartCacheTtl) {
          return Promise.resolve(window.__twCartCache);
        }

        if (window.__twCartRequestPromise) return window.__twCartRequestPromise;

        window.__twCartRequestPromise = fetch('/cart.js', {
          headers: { 'Accept': 'application/json' }
        })
          .then(function(response) {
            if (!response.ok) throw new Error('/cart.js failed with ' + response.status);
            // Ver nota en getCartSafely: /cart.js llega como "text/javascript",
            // el chequeo de content-type rechazaba toda respuesta válida.
            return response.json();
          })
          .then(function(cart) {
            window.__twCartCache = cart;
            window.__twCartCacheTimestamp = Date.now();
            return cart;
          })
          .finally(function() {
            window.__twCartRequestPromise = null;
          });

        return window.__twCartRequestPromise;
      };
    }

    if (!window.__twInvalidateCartCache) {
      window.__twInvalidateCartCache = function() {
        window.__twCartCache = null;
        window.__twCartCacheTimestamp = 0;
      };
    }

    function cartUnlocksUnitGate(cart) {
      if (!cart) return false;
      if ((cart.items_subtotal_price || 0) >= 5290) return true;
      var items = cart.items || [];
      for (var i = 0; i < items.length; i++) {
        var item = items[i] || {};
        var props = item.properties || {};
        for (var key in props) {
          if (!Object.prototype.hasOwnProperty.call(props, key)) continue;
          var h = String(key + ' ' + props[key]).toLowerCase();
          if (h.indexOf('bundle') > -1 || h.indexOf('rbr') > -1 || h.indexOf('fast bundle') > -1) return true;
        }
        var discounts = item.discounts || item.line_level_discount_allocations || [];
        for (var d = 0; d < discounts.length; d++) {
          var t = String((discounts[d] && (discounts[d].title || discounts[d].discount_application && discounts[d].discount_application.title)) || '').toLowerCase();
          if (t.indexOf('bundle') > -1 || t.indexOf('rbr') > -1 || t.indexOf('fast bundle') > -1) return true;
        }
      }
      return false;
    }

    function refreshWhenUnitGateUnlocks() {
      window.__twGetCartSafely(false)
        .then(function(cart) { if (cartUnlocksUnitGate(cart)) window.location.reload(); })
        .catch(function() {});
    }

    if (unitGateLocked) {
      document.addEventListener('cart:item-added', refreshWhenUnitGateUnlocks);
      document.addEventListener('cart:updated',    refreshWhenUnitGateUnlocks);
    }

    function cartHasPostPackUpsellTrigger(cart) {
      if (!cart) return false;
      var items = cart.items || [];
      for (var i = 0; i < items.length; i++) {
        var item = items[i] || {};
        var props = item.properties || {};
        for (var key in props) {
          if (!Object.prototype.hasOwnProperty.call(props, key)) continue;
          var h = String(key + ' ' + props[key]).toLowerCase();
          if (h.indexOf('yomi_pack_trigger') > -1 || h.indexOf('bundle') > -1 || h.indexOf('rbr') > -1 || h.indexOf('fast bundle') > -1 || h.indexOf('fastbundle') > -1) return true;
        }
        var discounts = item.discounts || item.line_level_discount_allocations || [];
        for (var d = 0; d < discounts.length; d++) {
          var t = String((discounts[d] && (discounts[d].title || discounts[d].discount_application && discounts[d].discount_application.title)) || '').toLowerCase();
          if (t.indexOf('bundle') > -1 || t.indexOf('rbr') > -1 || t.indexOf('fast bundle') > -1 || t.indexOf('fastbundle') > -1) return true;
        }
      }
      return false;
    }

    function setPostPackUpsellVisible(v) { document.querySelectorAll('[data-post-pack-upsell]').forEach(function(u) { u.hidden = !v; }); }

    function refreshPostPackUpsell() {
      if (!document.querySelector('[data-post-pack-upsell]')) return;
      window.__twGetCartSafely(false)
        .then(function(cart) { setPostPackUpsellVisible(cartHasPostPackUpsellTrigger(cart)); })
        .catch(function() {});
    }

    document.addEventListener('click', function(event) {
      var button    = event.target.closest('[data-post-pack-upsell-add]');
      if (!button) return;
      var variantId = button.getAttribute('data-post-pack-upsell-add');
      if (!variantId) return;
      event.preventDefault();
      button.disabled = true;
      fetch('/cart/add.js', {
        method:  'POST',
        headers: { 'Content-Type': 'application/json' },
        body:    JSON.stringify({ id: variantId, quantity: 1 })
      })
        .then(function(r) { if (!r.ok) throw new Error('Add failed'); return r.json(); })
        .then(function() {
          window.__twInvalidateCartCache();
          document.dispatchEvent(new CustomEvent('cart:item-added'));
          refreshPostPackUpsell();
        })
        .catch(function(e) { console.error('Error adding post-pack upsell:', e); })
        .finally(function() { button.disabled = false; });
    });

    refreshPostPackUpsell();
    document.addEventListener('tw-cart:drawer-ready', refreshPostPackUpsell);
    document.addEventListener('cart:item-added',      refreshPostPackUpsell);
    document.addEventListener('cart:updated',         refreshPostPackUpsell);

    var sections = document.querySelectorAll('section[id^="tw-main-product-"]');
    if (!sections.length) return;
    sections.forEach(function(sectionEl) {
      var sectionId = sectionEl.getAttribute('data-section-id') || sectionEl.id.replace('tw-main-product-', '');
      if (!sectionId) return;
      var form = document.getElementById('product-form-' + sectionId);
      if (!form) return;
      var productJson      = sectionEl.querySelector('[data-product-json]');
      var variantPricesJson = sectionEl.querySelector('[data-variant-prices]');
      var product           = productJson ? JSON.parse(productJson.textContent) : null;
      var variantPrices     = variantPricesJson ? JSON.parse(variantPricesJson.textContent) : {};
      if (!product) return;

      var hiddenId      = form.querySelector('input[name="id"]');
      var priceEl       = document.getElementById('price-' + sectionId);
      var submitBtn     = sectionEl.querySelector('.tw-pdp-buy-buttons__add') || sectionEl.querySelector('button[type="submit"][name="add"]');
      var addToCartLabel = submitBtn && submitBtn.getAttribute('data-add-to-cart');
      var soldOutLabel   = submitBtn && submitBtn.getAttribute('data-sold-out');
      var variantOptions = sectionEl.querySelectorAll('.tw-variant-option');

      function getSelectedOptions() {
        var byPosition = {};
        variantOptions.forEach(function(el) {
          var pos = parseInt(el.getAttribute('data-option-position'), 10) || 0;
          if (!byPosition[pos]) byPosition[pos] = [];
          byPosition[pos].push(el);
        });
        var positions = Object.keys(byPosition).map(Number).sort(function(a, b) { return a - b; });
        var opts = [];
        positions.forEach(function(pos) {
          var els = byPosition[pos];
          var val = null;
          els.forEach(function(el) {
            if (el.tagName === 'SELECT') val = el.value || null;
            else if (el.checked) val = el.value || null;
          });
          opts.push(val);
        });
        return opts;
      }

      function findVariant(opts) {
        for (var i = 0; i < product.variants.length; i++) {
          var v = product.variants[i];
          if (v.option1 === (opts[0] || null) && v.option2 === (opts[1] || null) && v.option3 === (opts[2] || null)) return v;
        }
        return null;
      }

      function updateForm(variant) {
        if (!variant) return;
        hiddenId.value = variant.id;
        if (variant.featured_media && variant.featured_media.position) {
          var gallery = document.querySelector('#tw-gallery-tw-main-product-' + sectionId);
          if (gallery && typeof gallery.goToSlide === 'function') gallery.goToSlide(variant.featured_media.position - 1);
        }
        if (priceEl && variantPrices[variant.id]) {
          var prices = variantPrices[variant.id];
          var priceSpan = priceEl.querySelector('.tw-product-price');
          if (priceSpan) priceSpan.textContent = prices.price;
          var compare = priceEl.querySelector('.tw-line-through');
          if (compare) {
            if (variant.compare_at_price > variant.price && prices.compare_at_price) { compare.textContent = prices.compare_at_price; compare.style.display = ''; }
            else compare.style.display = 'none';
          }
        }
        if (submitBtn && submitBtn.getAttribute('data-unit-redirect') !== 'true') {
          submitBtn.disabled    = !variant.available;
          submitBtn.textContent = variant.available ? (addToCartLabel || 'Agregar al carrito') : (soldOutLabel || 'Agotado');
        }
        sectionEl.querySelectorAll('.tw-pdp-buy-buttons__add').forEach(function(btn) {
          if (btn === submitBtn) return;
          if (btn.getAttribute('data-unit-redirect') === 'true') return;
          btn.disabled    = !variant.available;
          btn.textContent = variant.available ? (btn.getAttribute('data-add-to-cart') || 'Agregar al carrito') : (btn.getAttribute('data-sold-out') || 'Agotado');
        });
        var stickyPrice = sectionEl.querySelector('#tw-sticky-bar-price-' + sectionId);
        var stickyAdd   = sectionEl.querySelector('#tw-sticky-bar-add-' + sectionId);
        var stickyVariantSelect = sectionEl.querySelector('.tw-sticky-bar-variant');
        if (stickyPrice && variantPrices[variant.id]) stickyPrice.textContent = variantPrices[variant.id].price;
        if (stickyAdd && stickyAdd.getAttribute('data-unit-redirect') !== 'true') {
          stickyAdd.disabled    = !variant.available;
          stickyAdd.textContent = variant.available ? (stickyAdd.getAttribute('data-add-to-cart') || 'Agregar al carrito') : (stickyAdd.getAttribute('data-sold-out') || 'Agotado');
        }
        if (stickyVariantSelect) stickyVariantSelect.value = String(variant.id);
        var dynamicCheckout = sectionEl.querySelector('[data-dynamic-checkout-wrapper]');
        if (dynamicCheckout) dynamicCheckout.style.display = variant.available ? '' : 'none';
      }

      function syncStickyQuantityFromForm() {
        var mainQty  = form.querySelector('input[name="quantity"]');
        var stickyQty = sectionEl.querySelector('.tw-sticky-bar-quantity');
        if (mainQty && stickyQty) stickyQty.value = mainQty.value;
      }
      function syncFormQuantityFromSticky() {
        var mainQty  = form.querySelector('input[name="quantity"]');
        var stickyQty = sectionEl.querySelector('.tw-sticky-bar-quantity');
        if (mainQty && stickyQty) mainQty.value = stickyQty.value;
      }

      var triggerEl = sectionEl.querySelector('.tw-buy-buttons-trigger');
      var stickyBar = sectionEl.querySelector('.tw-sticky-add-cart');
      if (triggerEl && stickyBar) {
        syncStickyQuantityFromForm();
        var stickyVariantSelect = sectionEl.querySelector('.tw-sticky-bar-variant');
        if (stickyVariantSelect) {
          stickyVariantSelect.addEventListener('change', function() {
            var vid = parseInt(this.value, 10);
            var v   = product.variants.find(function(x) { return x.id === vid; });
            if (v) updateForm(v);
          });
        }
        var stickyQty = sectionEl.querySelector('.tw-sticky-bar-quantity');
        if (stickyQty) {
          stickyQty.addEventListener('change', syncFormQuantityFromSticky);
          stickyQty.addEventListener('input',  syncFormQuantityFromSticky);
          sectionEl.querySelectorAll('.tw-sticky-qty-minus, .tw-sticky-qty-plus').forEach(function(btn) {
            btn.addEventListener('click', function() {
              var n = parseInt(stickyQty.value, 10) || 1;
              stickyQty.value = btn.classList.contains('tw-sticky-qty-minus') ? Math.max(1, n - 1) : Math.min(99, n + 1);
              syncFormQuantityFromSticky();
            });
          });
        }
        var mainQtyInput = form.querySelector('input[name="quantity"]');
        if (mainQtyInput) {
          mainQtyInput.addEventListener('change', syncStickyQuantityFromForm);
          mainQtyInput.addEventListener('input',  syncStickyQuantityFromForm);
        }
        form.addEventListener('click', function(e) { if (e.target.closest('[data-qty-minus], [data-qty-plus]')) setTimeout(syncStickyQuantityFromForm, 0); });

        var stickyVisible = false;
        var footerEl      = document.querySelector('footer.tw-footer');
        var stickyBarH    = 80;
        function onScroll() {
          var triggerRect  = triggerEl.getBoundingClientRect();
          var viewportH    = window.innerHeight;
          var footerNear   = footerEl && footerEl.getBoundingClientRect().top < viewportH - stickyBarH;
          if (footerNear) {
            if (stickyVisible) { stickyBar.classList.remove('tw-translate-y-0'); stickyBar.classList.add('tw-translate-y-full'); stickyBar.setAttribute('aria-hidden', 'true'); stickyVisible = false; }
            return;
          }
          if (triggerRect.bottom <= 0) {
            if (!stickyVisible) { stickyBar.classList.add('tw-translate-y-0'); stickyBar.classList.remove('tw-translate-y-full'); stickyBar.setAttribute('aria-hidden', 'false'); stickyVisible = true; }
          } else {
            if (stickyVisible) { stickyBar.classList.remove('tw-translate-y-0'); stickyBar.classList.add('tw-translate-y-full'); stickyBar.setAttribute('aria-hidden', 'true'); stickyVisible = false; }
          }
        }
        window.addEventListener('scroll', onScroll, { passive: true });
        onScroll();
        var stickyAddBtn = sectionEl.querySelector('.tw-sticky-bar-add');
        if (stickyAddBtn && stickyAddBtn.getAttribute('data-unit-redirect') !== 'true') {
          stickyAddBtn.addEventListener('click', function() { if (form && !stickyAddBtn.disabled) form.requestSubmit(); });
        }
      }

      variantOptions.forEach(function(el) {
        el.addEventListener('change', function() {
          var opts    = getSelectedOptions();
          var variant = findVariant(opts);
          updateForm(variant);
          document.dispatchEvent(new CustomEvent('tw:variant-changed'));
        });
      });

      var currentVariantId = hiddenId && parseInt(hiddenId.value, 10);
      if (currentVariantId && product && product.variants) {
        var currentVariant = product.variants.find(function(v) { return v.id === currentVariantId; });
        if (currentVariant) updateForm(currentVariant);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tw-media-gallery-slide"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var section = document.querySelector('[data-tw-mgs]');
    if (!section || !section.querySelector('[data-tw-mgs-list]')) return;
    var list = section.querySelector('[data-tw-mgs-list]');
    var slides = section.querySelectorAll('[data-tw-mgs-slide]');
    var total = slides.length;
    if (total <= 0) return;
    var index = 0;
    var autoplay = section.getAttribute('data-autoplay') === 'true';
    var speed = parseInt(section.getAttribute('data-speed'), 10) || 5000;
    var timer = null;
    function goTo(i) {
      index = (i + total) % total;
      list.style.transform = 'translateX(-' + (index * 100) + '%)';
    }
    function next() { goTo(index + 1); }
    section.querySelector('[data-tw-mgs-prev]') && section.querySelector('[data-tw-mgs-prev]').addEventListener('click', function() { goTo(index - 1); if (timer) clearInterval(timer); if (autoplay) timer = setInterval(next, speed); });
    section.querySelector('[data-tw-mgs-next]') && section.querySelector('[data-tw-mgs-next]').addEventListener('click', function() { goTo(index + 1); if (timer) clearInterval(timer); if (autoplay) timer = setInterval(next, speed); });
    goTo(0);
    if (autoplay && total > 1) timer = setInterval(next, speed);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tw-minicart-form"] && !Shopify.designMode) return;
  try {
    
  (function() {
    function loadUpsells() {
      document.querySelectorAll('.tw-cart-upsell--fetch').forEach(function(el) {
        if (!el.dataset.url) return;
        if (el.dataset.loaded) return;
        var grid = el.querySelector('.tw-cart-upsell__grid');
        if (!grid) return;
        el.dataset.loaded = 'true';
        fetch(el.dataset.url)
          .then(function(r) { return r.ok ? r.text() : Promise.reject(); })
          .then(function(html) {
            var wrap = document.createElement('div');
            wrap.innerHTML = html;
            var sectionId = (el.dataset.sectionId || 'tw-cart-upsell').replace(/\W/g, '-');
            var sectionEl = wrap.querySelector('#shopify-section-' + sectionId + ' .tw-cart-upsell__grid');
            if (!sectionEl && wrap.querySelector('.tw-cart-upsell__grid')) sectionEl = wrap.querySelector('.tw-cart-upsell__grid');
            if (sectionEl && sectionEl.innerHTML.trim()) {
              grid.innerHTML = sectionEl.innerHTML;
              grid.classList.remove('tw-cart-upsell__grid--placeholder');
            } else {
              el.style.display = 'none';
            }
          })
          .catch(function() { el.style.display = 'none'; });
      });
    }
    
    loadUpsells();
    
    document.addEventListener('cart:drawer-open', loadUpsells);
    var cartDrawer = document.querySelector('[data-drawer]');
    if (cartDrawer) {
      var observer = new MutationObserver(function(mutations) {
        mutations.forEach(function(mutation) {
          if (mutation.attributeName === 'open' || mutation.attributeName === 'class') {
            var isOpen = cartDrawer.hasAttribute('open') || cartDrawer.classList.contains('open') || cartDrawer.classList.contains('is-open');
            if (isOpen) loadUpsells();
          }
        });
      });
      observer.observe(cartDrawer, { attributes: true, attributeFilter: ['open', 'class'] });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tw-pickup-availability"] && !Shopify.designMode) return;
  try {
    
  (function() {
    const section = document.querySelector('[data-tw-pickup-drawer]') && document.querySelector('[data-tw-pickup-drawer]').closest('.tw-pickup-availability');
    if (!section) return;
    const trigger = section.querySelector('[data-tw-pickup-trigger]');
    const drawer = section.querySelector('[data-tw-pickup-drawer]');
    const closeBtns = section.querySelectorAll('[data-tw-pickup-close]');
    function open() {
      if (drawer) drawer.classList.remove('tw-hidden');
      if (trigger) trigger.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
    }
    function close() {
      if (drawer) drawer.classList.add('tw-hidden');
      if (trigger) trigger.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
    }
    if (trigger) trigger.addEventListener('click', open);
    closeBtns.forEach(function(btn) { btn.addEventListener('click', close); });
    if (drawer) drawer.addEventListener('keydown', function(e) {
      if (e.key === 'Escape') close();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tw-slideshow-banner"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var wrap = document.querySelector('[data-tw-sb]');
    if (!wrap || !wrap.querySelector('[data-tw-sb-list]')) return;
    var list = wrap.querySelector('[data-tw-sb-list]');
    var slides = wrap.querySelectorAll('[data-tw-sb-slide]');
    var n = slides.length;
    if (n <= 0) return;
    var idx = 0;
    var autoplay = wrap.getAttribute('data-autoplay') === 'true';
    var speed = parseInt(wrap.getAttribute('data-speed'), 10) || 5000;
    var t = null;
    function go(i) {
      idx = (i + n) % n;
      list.style.transform = 'translateX(-' + (idx * 100) + '%)';
    }
    function next() { go(idx + 1); }
    if (wrap.querySelector('[data-tw-sb-prev]')) wrap.querySelector('[data-tw-sb-prev]').addEventListener('click', function() { go(idx - 1); if (t) clearInterval(t); if (autoplay) t = setInterval(next, speed); });
    if (wrap.querySelector('[data-tw-sb-next]')) wrap.querySelector('[data-tw-sb-next]').addEventListener('click', function() { go(idx + 1); if (t) clearInterval(t); if (autoplay) t = setInterval(next, speed); });
    go(0);
    if (autoplay && n > 1) t = setInterval(next, speed);
  })();

  } catch(e) { console.error(e); }
})();
})();
